module.exports = __webpack_public_path__ + "img/ico-play1.06f9bf82.png";